var map = {
	"./pg3/Pages/RecommendationListScreen/PatientRecommendationList": [
		240,
		0,
		6,
		10,
		69
	],
	"./purepro/Pages/RecommendationListScreen/PatientRecommendationList": [
		241,
		0,
		2,
		3,
		6,
		24
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 176;
module.exports = webpackAsyncContext;